<template>
  <div>
    <FileUploadForm />
  </div>
</template>

<script>
import FileUploadForm from '../../components/Forms/FIleUploadForm'

export default {
  name: 'FileUpload',
  components: { FileUploadForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/FileMgmt/FileUpload.vue?15d694a2